import type { Ctx } from 'boardgame.io';
import { debug } from '../../utils/debug';
import type { AoSGameState } from '../../types';

/**
 * Phase 5（商品輸送）でPassを選択するMove
 *
 * 何もせず手番を終了します。
 * 輸送回数上限（デフォルト2回）のうち、1回をスキップすることができます。
 *
 * @param G - ゲーム状態
 * @param ctx - Boardgame.ioコンテキスト
 *
 * @see docs/specifications/logic/common/phase_05_move_goods.md
 */
export function passMoveGoods(
  { G, ctx }: { G: AoSGameState; ctx: Ctx }
): void {
  const player = G.players[ctx.currentPlayer];
  const maxDeliveries = G.maxDeliveriesThisPhase ?? 2;

  // 手番回数カウント（何もせず手番を終了）
  player.turnsCompletedThisPhase += 1;

  debug.log(`[passMoveGoods] Player ${ctx.currentPlayer} passed turn ${player.turnsCompletedThisPhase}/${maxDeliveries} (transported: ${player.goodsTransportedThisPhase}, upgraded: ${player.hasUpgradedLocoThisTurn})`);
}
